/**
 * Appointments signal — how a booking or a check-in made OUTSIDE the پذیرش screen
 * reaches the day list that is showing those rows.
 *
 * The «منشی هوشمند» overlay is mounted in the shell and can mark a patient arrived
 * or book an appointment while پذیرش is the screen underneath. پذیرش polls every
 * 20 seconds, so without this the desk would press «ثبت حضور», watch the overlay
 * close, and see the row unchanged — which reads as «it did not work».
 *
 * Shaped like `paywallSignal.js`: a module-level subscriber set, because the
 * producer and the consumer share no React parent worth threading a context
 * through. It carries no payload on purpose — the listener re-reads from the
 * server, which is the only copy of the truth.
 */

const listeners = new Set();

/** Subscribe. Returns the unsubscribe function, so an effect can return it directly. */
export function onAppointmentsChanged(handler) {
  if (typeof handler !== 'function') return () => {};
  listeners.add(handler);
  return () => listeners.delete(handler);
}

/** Say that appointments changed somewhere else. Never throws. */
export function reportAppointmentsChanged() {
  for (const handler of Array.from(listeners)) {
    try {
      handler();
    } catch (err) {
      console.error('appointments listener failed:', err);
    }
  }
}
